// Mobile Cart Summary Component
// Bottom sheet style cart summary for mobile

import { useNavigate } from 'react-router-dom';
import { useCart } from '@/contexts/CartContext';
import styles from './MobileCartSummary.module.css';

interface MobileCartSummaryProps {
  className?: string;
}

export function MobileCartSummary({ className }: MobileCartSummaryProps) {
  const navigate = useNavigate();
  const { itemCount, total } = useCart();

  // Format price
  const formatPrice = (price: number) => {
    return `$${Math.round(price).toLocaleString()}`;
  };

  if (itemCount === 0) {
    return null;
  }

  return (
    <div className={`${styles.mobileSummary} ${className || ''}`}>
      <div className={styles.summary}>
        <div className={styles.itemInfo}>
          <span className={styles.count}>{itemCount} 件商品</span>
          <span className={styles.total}>{formatPrice(total)}</span>
        </div>
        <button
          className={styles.checkoutButton}
          onClick={() => navigate('/checkout')}
        >
          前往結帳
        </button>
      </div>
    </div>
  );
}
